// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: memory.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "com.darwin.memory";

/** Origin of an analyst memory fact. */
export enum MemorySource {
  MANUAL = 0,
  AGENT = 1,
  UNRECOGNIZED = -1,
}

export function memorySourceFromJSON(object: any): MemorySource {
  switch (object) {
    case 0:
    case "MANUAL":
      return MemorySource.MANUAL;
    case 1:
    case "AGENT":
      return MemorySource.AGENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MemorySource.UNRECOGNIZED;
  }
}

export function memorySourceToJSON(object: MemorySource): string {
  switch (object) {
    case MemorySource.MANUAL:
      return "MANUAL";
    case MemorySource.AGENT:
      return "AGENT";
    case MemorySource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * A structured memory record attached to an analyst.
 * Stored in Darwin's DB; field numbers must remain stable.
 */
export interface MemoryFactProto {
  /** UUID primary key. */
  id?:
    | string
    | undefined;
  /** Plain-text instruction content. */
  text?:
    | string
    | undefined;
  /** When false the fact is excluded from the prompt. Defaults to true. */
  enabled?:
    | boolean
    | undefined;
  /** Whether the fact was typed manually or extracted by the agent post-run. */
  source?:
    | MemorySource
    | undefined;
  /** User ID that created this fact; null when source=AGENT. */
  added_by?:
    | string
    | undefined;
  /** Creation timestamp in epoch milliseconds. */
  created_at?:
    | number
    | undefined;
  /** Chat session that generated this fact (only set when source=AGENT). */
  session_id?: string | undefined;
}

function createBaseMemoryFactProto(): MemoryFactProto {
  return {
    id: undefined,
    text: undefined,
    enabled: undefined,
    source: undefined,
    added_by: undefined,
    created_at: undefined,
    session_id: undefined,
  };
}

export const MemoryFactProto: MessageFns<MemoryFactProto> = {
  encode(message: MemoryFactProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.text !== undefined) {
      writer.uint32(18).string(message.text);
    }
    if (message.enabled !== undefined) {
      writer.uint32(24).bool(message.enabled);
    }
    if (message.source !== undefined) {
      writer.uint32(32).int32(message.source);
    }
    if (message.added_by !== undefined) {
      writer.uint32(42).string(message.added_by);
    }
    if (message.created_at !== undefined) {
      writer.uint32(48).int64(message.created_at);
    }
    if (message.session_id !== undefined) {
      writer.uint32(58).string(message.session_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MemoryFactProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMemoryFactProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.source = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.added_by = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.created_at = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.session_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MemoryFactProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      text: isSet(object.text) ? globalThis.String(object.text) : undefined,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : undefined,
      source: isSet(object.source) ? memorySourceFromJSON(object.source) : undefined,
      added_by: isSet(object.added_by) ? globalThis.String(object.added_by) : undefined,
      created_at: isSet(object.created_at) ? globalThis.Number(object.created_at) : undefined,
      session_id: isSet(object.session_id) ? globalThis.String(object.session_id) : undefined,
    };
  },

  toJSON(message: MemoryFactProto): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.text !== undefined) {
      obj.text = message.text;
    }
    if (message.enabled !== undefined) {
      obj.enabled = message.enabled;
    }
    if (message.source !== undefined) {
      obj.source = memorySourceToJSON(message.source);
    }
    if (message.added_by !== undefined) {
      obj.added_by = message.added_by;
    }
    if (message.created_at !== undefined) {
      obj.created_at = Math.round(message.created_at);
    }
    if (message.session_id !== undefined) {
      obj.session_id = message.session_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MemoryFactProto>, I>>(base?: I): MemoryFactProto {
    return MemoryFactProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MemoryFactProto>, I>>(object: I): MemoryFactProto {
    const message = createBaseMemoryFactProto();
    message.id = object.id ?? undefined;
    message.text = object.text ?? undefined;
    message.enabled = object.enabled ?? undefined;
    message.source = object.source ?? undefined;
    message.added_by = object.added_by ?? undefined;
    message.created_at = object.created_at ?? undefined;
    message.session_id = object.session_id ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
